import Text from './../../node_modules/ol/style/Text.js';

Text.prototype.setTextRepeat = function(repeat) {
    this.textrepeat_ = repeat;
}

Text.prototype.getTextRepeat = function() {
    return this.textrepeat_;
}

Text.prototype.setTextJustify = function(justify) {
    this.textjustify_ = justify;
}

Text.prototype.getTextJustify = function() {
    return this.textjustify_;
}

Text.prototype.setPlacement = function(placement) {
    this.placement_ = placement;
}

Text.prototype.getPlacement = function() {
    return this.placement_;
}

Text.prototype.clone = function(){
    const scale = this.getScale();
    return new Text({
        font: this.getFont(),
        placement: this.getPlacement(),
        repeat: this.getRepeat(),
        maxAngle: this.getMaxAngle(),
        overflow: this.getOverflow(),
        rotation: this.getRotation(),
        rotateWithView: this.getRotateWithView(),
        keepUpright: this.getKeepUpright(),
        scale: Array.isArray(scale) ? scale.slice() : scale,
        text: this.getText(),
        textAlign: this.getTextAlign(),
        justify: this.getJustify(),
        textBaseline: this.getTextBaseline(),
        fill: this.getFill() ? this.getFill().clone() : undefined,
        stroke: this.getStroke() ? this.getStroke().clone() : undefined,
        offsetX: this.getOffsetX(),
        offsetY: this.getOffsetY(),
        backgroundFill: this.getBackgroundFill()
            ? this.getBackgroundFill().clone()
            : undefined,
        backgroundStroke: this.getBackgroundStroke()
            ? this.getBackgroundStroke().clone()
            : undefined,
        padding: this.getPadding() || undefined,
        declutterMode: this.getDeclutterMode(),
        textRepeat: this.getTextRepeat(),
        textJustify: this.getTextJustify(),
    });
}

export default Text;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/style/Text.js';